import _ from 'lodash';

import Broadcast from "./Broadcast";

const Service = class {

	static COMPLEX_PROPS = ["options", "Tags", "props"];

	constructor(properties) {

		const mixins = properties.Libraries || [];

		delete properties.Libraries;

		let init = function() {};

		if (!this.Actions) this.Actions = {};

		if (!this.Events) this.Events = {};

		if (properties.init) init = properties.init;

		if (!properties.Name) throw new Error("Service must have own Name property! " + this.Name);

		Object.assign(this, properties);

		for (let i = 0; mixins[i]; i++) {

			if (!mixins[i].Name) throw new Error("Library must have own Name property! " + this.Name);

			Object.assign(this, _.omit(mixins[i], ['init', 'Name', 'Actions', 'Routes', 'Events']));

		}

		this.init = () => {

			this.activateActions(properties.Actions, properties.Name, this);

			for (let i=0; mixins[i]; i++) {

				this.activateActions(mixins[i].Actions, mixins[i].Name, this);

			}

			Broadcast.call('Service Actions Activated', [this, mixins]);

			this.activateEvents(properties.Events, properties.Name, this);

			for (let i=0; mixins[i]; i++) {

				this.activateEvents(mixins[i].Events, mixins[i].Name, this);

			}

			Broadcast.call('Service Events Activated', [this, mixins]);

			init.apply(this, []);

			for (let i=0; mixins[i]; i++) {

				if (mixins[i].init) mixins[i].init.apply(this, []);

			}

			Broadcast.call('Service Init', [this, mixins]);

		};

		if (!properties["disableAutoInit"]) this.init();

	}

	// Карта одной ноды кластера: у каждой ноды своя БД, поэтому карты данных сервисов разделены
	// по нодам (`<Карта>ByServer[serverId]`, ключ - номер ноды). Активные карты сервиса - это ссылки
	// на карты рабочей ноды, поэтому в них ключом служит только id сущности
	getServerMap(mapsByServer, serverId) {

		if (!mapsByServer[serverId]) mapsByServer[serverId] = {};

		return mapsByServer[serverId];

	}

	activateActions(actions, screenName, context) {

		Broadcast.on('Server Data Received', (data, size, serverId) => {

			_.each(actions, (fn, key) => {

				if (data && key in data) fn.apply(context, [data[key], data, size, serverId]);

			});

			if (actions?.['*']) {

				actions['*'].apply(context, [data, size, serverId]);

			}

		}, screenName + ':init');

	}

	activateEvents(events, screenName, context) {

		_.each(events, (fn, event_name) => {

			Broadcast.on(event_name, (...args) => {

				fn.apply(context, args);

			}, screenName + ':init');

		});

	}

	broadcastChanges(oldObject, newObject, eventPrefixes, options = {}) {

		if (!_.isArray(eventPrefixes)) eventPrefixes = [eventPrefixes];

		if (!options.excludeKeys) options.excludeKeys = [];

		if (oldObject) {

			if (newObject) {

				let keys = _.uniq(_.concat(_.keys(newObject), _.keys(oldObject))),
					changedKeys = [];

				// Уберём объекты и массивы так как они всегда будут показывать якобы изменены
				let primitiveKeys = _.without(keys, ...Service.COMPLEX_PROPS, ...options.excludeKeys);

				_.each(primitiveKeys, key => {

					if (!_.isEqual(newObject[key], oldObject[key])) {

						changedKeys.push(key);

					}

				});

				// Отдельно проверим объекты на один уровень
				let objectKeys = _.without(_.intersection(Service.COMPLEX_PROPS, keys), ...options.excludeKeys);

				_.each(objectKeys, objectKey => {

					let keys = _.uniq(_.concat(_.keys(newObject[objectKey]), _.keys(oldObject[objectKey])));

					_.each(keys, key => {

						if (!_.isEqual(newObject[objectKey][key], oldObject[objectKey]?.[key])) {

							if (!_.includes(changedKeys, objectKey)) {

								changedKeys.push(objectKey);
								changedKeys.push(`${objectKey}.${key}`);

							}

						}

					});

				});

				if (changedKeys.length > 0) for (let i=0; eventPrefixes[i]; i++) Broadcast.call(`${eventPrefixes[i]} Changed: [${changedKeys.join('|')}]`, [newObject, oldObject, changedKeys, options]);

			} else {

				for (let i=0; eventPrefixes[i]; i++) Broadcast.call(`${eventPrefixes[i]} Removed`, [oldObject, options]);

			}

		} else {

			if (newObject) {

				for (let i=0; eventPrefixes[i]; i++) Broadcast.call(`${eventPrefixes[i]} Added`, [newObject, options]);

			} else {

				// Ничего не было и пришло с сервера опять ничего...

			}

		}

	}

};

export default Service;
